import React, { useMemo } from 'react'
import { Tabs, Typography } from 'antd'
import { useSelector } from 'react-redux'

import { RequestQuoteAirGroup } from 'src/types'

import { ApplicationState } from 'src/store'
import { Button, Modal } from 'src/components/Ant'

import { WrapCard } from './styles'
import SearchResultItemHistory from './search-result-item-history'

type MergedRoute = {
  title: string
  request_quote_air_groups: RequestQuoteAirGroup[]
}

type Props = {
  toggle(): void
  visible: boolean
}

function ModalHistory({ toggle, visible }: Props) {
  const {
    air: { historyError, historyList, historyLoading }
  } = useSelector((state: ApplicationState) => ({
    air: state.air
  }))

  const routes = useMemo<MergedRoute[]>(() => {
    const mergedRoutes: MergedRoute[] = []
    if (!historyError && historyList.length > 0 && !historyLoading) {
      historyList.forEach(airItem => {
        airItem.request_quote_air_routes?.[0]?.request_quote_air_groups.forEach(
          quoteAirGroupItem => {
            const routeKey = quoteAirGroupItem.journey
            if (!mergedRoutes[routeKey]) {
              mergedRoutes[routeKey] = {
                title: `${quoteAirGroupItem.request_quote_airs[0].air_origin} - ${quoteAirGroupItem.request_quote_airs[0].air_destiny}`,
                request_quote_air_groups: []
              }
            }
            mergedRoutes[routeKey].request_quote_air_groups.push(
              quoteAirGroupItem
            )
          }
        )
      })
    }

    return mergedRoutes
  }, [historyError, historyList, historyLoading])

  return (
    <Modal
      closable
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            toggle()
          }}
          size="default"
          title="common.actions.cancel"
          type="default"
        />
      ]}
      forceRender
      maskClosable
      onCancel={() => {
        toggle()
      }}
      title="web.services.airs.history-title"
      visible={visible}
      width={900}
    >
      {historyError ? (
        <Typography.Text>{historyError}</Typography.Text>
      ) : (
        <WrapCard loading={historyLoading}>
          <Tabs defaultActiveKey="0">
            {routes.map(({ request_quote_air_groups, title }, routeIndex) => (
              <Tabs.TabPane tab={title} key={`${routeIndex}`}>
                <SearchResultItemHistory journeys={request_quote_air_groups} />
              </Tabs.TabPane>
            ))}
          </Tabs>
        </WrapCard>
      )}
    </Modal>
  )
}

export default ModalHistory
